import { type AdChannel, channelLabel } from '../campaignChannels';
import './campaign-journey.css';

export function CampaignJourneyGuide({ channels }: { channels: AdChannel[] }) {
  return <section className="campaign-journey-guide">
    <h3>Um briefing comum. Anúncios próprios para cada canal.</h3>
    <ol className="campaign-journey-steps">
      <li><strong>1. Briefing</strong><span>Objetivo, oferta, público, destino, orçamento, canais e contas.</span></li>
      <li><strong>2. Revisar anúncios</strong><span>Confira o conteúdo de cada canal.</span></li>
      <li><strong>3. Aprovar e publicar</strong><span>Aprove a revisão. Depois publique em cada conta.</span></li>
      <li><strong>4. Acompanhar</strong><span>Ative os canais vinculados e confira os resultados.</span></li>
    </ol>
    <p>O briefing orienta Meta e Google. A mesma oferta é adaptada ao formato de anúncio de cada canal na etapa 2.</p>
    <div className="campaign-journey-formats">
      {channels.map(channel => <p key={channel}><strong>{channelLabel(channel)}:</strong>{' '}
        {channel === 'meta' ? 'imagens ou vídeos + texto para Facebook e Instagram.' : 'títulos + descrições + palavras-chave para a Pesquisa Google. Não exige arte.'}
      </p>)}
    </div>
    {channels.length === 2 && <p>Publicar na Meta não publica no Google. Cada canal tem seu botão, sua conta e seu resultado.</p>}
  </section>;
}
